import { render, staticRenderFns } from "./jade.vue?vue&type=template&id=674f3e81"
import script from "./jade.vue?vue&type=script&lang=js"
export * from "./jade.vue?vue&type=script&lang=js"
import style0 from "./jade.vue?vue&type=style&index=0&id=674f3e81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports